import { useEffect } from 'react';

interface JsonLdProps {
  data: Record<string, unknown> | Record<string, unknown>[];
}

export default function JsonLd({ data }: JsonLdProps) {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    
    // Helper function to replace placeholder URLs with actual site URL
    const replaceUrls = (obj: unknown): unknown => {
      if (typeof obj === 'string') {
        return obj.replace(/https:\/\/example\.com/g, siteUrl);
      }
      if (Array.isArray(obj)) {
        return obj.map(replaceUrls);
      }
      if (obj && typeof obj === 'object') {
        const result: Record<string, unknown> = {};
        for (const [key, value] of Object.entries(obj)) {
          result[key] = replaceUrls(value);
        }
        return result;
      }
      return obj;
    };

    const processedData = replaceUrls(data);
    const jsonString = JSON.stringify(processedData);
    
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = jsonString;
    script.setAttribute('data-jsonld', 'true');
    document.head.appendChild(script);

    return () => {
      const scripts = document.head.querySelectorAll('script[data-jsonld="true"]');
      scripts.forEach(s => s.remove());
    };
  }, [data]);

  return null;
}